module.exports = __webpack_public_path__ + "media/video3.2d911666.mp4";